import type { IWidgetConfig } from "../shared/session/interfaces/session";
import { PayoutMethodType } from "../interfaces/payout";

/** Payout method/network/details editable only when explicitly enabled. */
export function isPayoutEditable(
  config: Pick<IWidgetConfig, "allowPayoutEdit"> | undefined,
): boolean {
  return config?.allowPayoutEdit === true;
}

/** Explicit split flag wins; legacy payout=true preserves combined behavior. */
export function isDestinationCurrencyEditable(
  config:
    | Pick<
        IWidgetConfig,
        "allowPayoutEdit" | "allowDestinationCurrencyEdit"
      >
    | undefined,
): boolean {
  if (config?.allowDestinationCurrencyEdit === true) return true;
  if (config?.allowDestinationCurrencyEdit === false) return false;
  return config?.allowPayoutEdit === true;
}

/**
 * CVS payout preparation applies only to destination-card rails the payer
 * chose. The requester's own card arrives masked in the claim and is resolved
 * server-side at create, so it must never go through register / provision.
 */
export function shouldPreparePayoutRail(
  payoutEditable: boolean,
  method: PayoutMethodType | null | undefined,
  origin: "claim" | "user" | undefined,
): boolean {
  return (
    payoutEditable &&
    origin === "user" &&
    method === PayoutMethodType.PUSH_TO_CARD
  );
}
